import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-phone-component',
  templateUrl: './phone-component.component.html',
  styleUrl: './phone-component.component.scss'
})
export class PhoneComponentComponent {
  @Input({ required: true }) control: FormControl;

  @Input({ required: false }) label?: string;
  @Input({ required: true }) placeholder: string;
  @Input({ required: true }) errorMessage: string;

  @Input({ required: false }) width = "30%";
  @Input({ required: false }) isResponsive = true;

  isInvalid(): boolean {
    const control = this.control;
    return control ? control.invalid && (control.dirty || control.touched) : false;
  }
}
